import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=4c70b3d2&"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js&"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports